<template>
  <div class="about mt-0 mt-lg-5 pl-2 pl-lg-0 pr-2 pr-lg-0">
    <div  class="container mt-3 mb-3 mt-lg-5 mb-lg-5">
      <div class="row">
        <md-card class="m-0 col-12 md-elevation-6">
          <md-card-header>
            <div class="col-12">
              <h2 class="md-title font-weight-bold m-0">Quem Somos?</h2>
            </div>
          </md-card-header>
          <md-divider></md-divider>
          <!-- <md-tabs class="m-0" md-elevation md-dynamic-height md-alignment="fixed"> -->
            <!-- <md-tab id="tab-missao"> -->
              <md-card-content>
                <h6 class="md-subheading">
                  <!-- line-height: 1.2;
                      line-height: 1.2;
                      line-height: 1.2;
                  -->
                  <p align="justify" style="text-indent: 40px;">A VirteX Telecom é um provedor de internet e serviços de tecnologia fundado no ano de 2002 na cidade de Picos-PI. Atualmente temos atuação nos estados do Piauí, Pernambuco e Maranhão, e estamos em constante crescimento.</p>
                  <p align="justify" style="text-indent: 40px;">Somos uma empresa consolidada no mercado, premiada com o selo “Melhor Plano” de “Maior Satisfação do Brasil” e selo GPTW de melhores empresas para se trabalhar desde 2021. Temos uma cultura organizacional que se importa com a satisfação do cliente, de um jeito simples, inovador e baseado em 5 Princípios: - Propósito; Diferenciais; Ética; Gestão; e principalmente Pessoas.</p>
                  <p align="justify" style="text-indent: 40px;">Prezamos por fornecer um serviço de qualidade, sempre buscando trabalhar com as melhores pessoas, parceiros, marcas e tecnologias.</p>
                 <p><b>- MISSÃO</b></p>

                  <p align="justify" style="text-indent: 40px;">Conectar pessoas e negócios, atender às necessidades e desejos dos nossos clientes de internet e outros serviços, assim como gerar os melhores resultados.</p>
                  <p><b>- VISÃO</b></p>
                  <p align="justify" style="text-indent: 40px;">Tornar-se a plataforma de referência em serviços que proporcionem conectividade, comodidade, negócios e lazer, estando entre as 5 melhores empresas do ramo através de uma Cultura Organizacional sólida que realmente se importa com o bem estar e satisfação dos nossos colaboradores e clientes, tudo de um jeito simples e inovador, gerando resultados positivos que garantam a nossa longevidade.</p>

                   <p><b>- VALORES</b></p>
                  <p align="justify" style="text-indent: 40px;">Nossos valores estão baseados em cinco princípios:</p>
                  <ul>
                    <li><b>Propósito</b></li>
                    <ul><li>Foco na satisfação do cliente e do colaborador.</li></ul>
                    <li><b>Diferenciais</b></li>
                    <ul><li>Escutar, entender, para depois executar. Comprometimento com a melhoria contínua para manter a excelência.</li></ul>
                    <li><b>Ética</b></li>
                    <ul><li>Não negociamos caráter. Compromisso e respeito com todos os colaboradores, clientes, fornecedores, parceiros, governo e sociedade trazem longevidade e sucesso.</li></ul>
                    <li><b>Gestão</b></li>
                    <ul><li>Visão 360 graus, liderança pelo exemplo, meritocracia, consistência e simplicidade.</li></ul>
                    <li><b>Pessoas</b></li>
                    <ul><li>Nosso maior patrimônio e diferencial. Investimos em capacitação e na busca de talentos. Determinação, força de vontade, equipe unida e feliz fazem os melhores resultados.</li></ul>
                  </ul>





                </h6>
              </md-card-content>
            <!-- </md-tab> -->
            <!-- <md-tab id="tab-visao" md-label="Visão">
              <md-card-content>
                <h6 class="md-subheading">
                  Ser reconhecida pelos clientes através da qualidade do seu atendimento e serviços prestados, inovando sempre, tornando-se referência no mercado regional e brasileiro como uma empresa de valores éticos que cumpre efetivamente o objeto de sua missão.
                </h6>
              </md-card-content>
            </md-tab>
            <md-tab id="tab-valores" md-label="Valores">
              <md-card-content>
                <h6 class="md-subheading">
                  Sobre nossos valores e princípios tais como ética e responsabilidade, destacamos o amor ao negócio, que nos motiva a buscar soluções e tecnologias que atendam necessidades e superem expectativas, trazendo com isto proximidade e respeito dos clientes, fornecedores, sociedade e amigos.
                </h6>
              </md-card-content>
            </md-tab>

            <md-tab id="tab-politica" md-label="Política de Qualidade">
              <md-card-content>
                <h6 class="md-subheading">
                  Fornecer principalmente serviços de internet com estabilidade, atendimento ágil e personalizado, com inserção de novas tecnologias e opções diferenciadas atendendo as necessidades de cada perfil, pois a satisfação de nossos clientes está em primeiro lugar.
                  <br/>
                  Fornecer aos colaboradores a melhoria contínua dos processos, tecnologias aplicadas e desenvolvimento das suas competências, trazendo oportunidades de crescer e se especializar para se tornar não só um profissional, mas um cidadão melhor para a empresa, sua família e sociedade.
                </h6>
              </md-card-content>
            </md-tab> -->
          <!-- </md-tabs> -->
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutArea"
};
</script>

<style scoped lang="scss">
.about {
  display: flex;
  background-image: linear-gradient(to top, #c4c5c7 0%, #dcdddf 52%, #ebebeb 100%);
  position: relative;
  width: 100%;
  overflow: hidden;
}
</style>
